import { useCallback, useEffect, useState } from 'react';
import { vehicleImageService } from '../services/vehicle-image-service/vehicle-image-service';

export type ImageOptions = {
    angle?: number | undefined;
};

export const useVehicleImage = (
    vehicleAttributes: { vin?: string; year?: number } | null,
    lazy = false,
    options?: ImageOptions
): {
    vehicleImage: string | null;
    queryVehicleImage: (year: number, vin: string) => void;
} => {
    const [vehicleImage, setVehicleImage] = useState<string | null>('');

    const runQuery = useCallback(
        (year: number, vin: string) => {
            if (vehicleAttributes?.vin && vehicleAttributes?.year) {
                vehicleImageService
                    .getVehicleImage({ year, vin }, options?.angle)
                    .then(vehicleImageUrl => {
                        setVehicleImage(vehicleImageUrl);
                    });
            }
        },
        [vehicleAttributes?.vin, vehicleAttributes?.year, options?.angle]
    );

    useEffect(() => {
        if (
            !lazy &&
            vehicleAttributes &&
            vehicleAttributes.vin &&
            vehicleAttributes.year &&
            vehicleAttributes.vin !== ''
        ) {
            runQuery(vehicleAttributes.year, vehicleAttributes.vin);
        }
    }, [vehicleAttributes]);

    return { vehicleImage, queryVehicleImage: runQuery };
};
